import { resolveArticleHeroMedia } from '../../../shared/domain/articleHeroMedia';
import type { ArticleRow } from '../../../shared/schemas/article';

const FULL_MDA_IDS = [
  'app-demo',
  'agents-demo',
  'connector-demo',
  'github-demo',
] as const;

export type FullMdaId = (typeof FULL_MDA_IDS)[number];

function resolveFeatureCardDemoId(article: {
  dmc_id?: string | null;
}): string | null {
  return article.dmc_id ?? null;
}

export function resolveFeatureCardHeroProps(article: ArticleRow): {
  heroMedia: ArticleRow['hero_media'];
  miniDemoId: string | undefined;
} {
  const resolved = resolveArticleHeroMedia({
    hero_media: article.hero_media,
    mini_demo_id: article.mini_demo_id,
  });
  const dmcId = resolveFeatureCardDemoId(article);

  if (resolved?.kind === 'image' || resolved?.kind === 'video') {
    return {
      heroMedia: article.hero_media ?? undefined,
      miniDemoId: undefined,
    };
  }

  if (resolved?.kind === 'demo' && dmcId) {
    return {
      heroMedia: undefined,
      miniDemoId: dmcId,
    };
  }

  return {
    heroMedia: article.hero_media ?? undefined,
    miniDemoId: article.mini_demo_id ?? dmcId ?? undefined,
  };
}

function resolveFullMdaId(miniDemoId: string | null | undefined): FullMdaId | null {
  if (!miniDemoId) return null;
  if ((FULL_MDA_IDS as readonly string[]).includes(miniDemoId)) {
    return miniDemoId as FullMdaId;
  }
  return null;
}

export function featureArticleHref(slug: string): string {
  return `/features/${slug}`;
}
